export class RegionMetaDataModel{
    id:number;
    name:string;
    regionNameID:string;
    regionID:number;
    area:number;
    wkt:string;
    numberOfBuilding:number;
    numberOfRack:number;
    numberOfComponent:number;
    numberOfDuct:number;
    numberOfCable:number;
    numberOfServices:number;
    numberOfRedlinings:number;
}
